/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { Button } from '@zapier/design-system';

type Props = {
  onClick: () => void;
};

export const ExtendTrialButton = ({ onClick }: Props) => (
  <Button color="greyAlt" onClick={onClick}>
    Start Trial
  </Button>
);
